import { trackEvent } from 'dibs-tracking';
import serverVars from 'server-vars';

import { FEATURE_RAMP_CONFIG } from './constants';
import { FeatureRampConfig } from './types';

export const trackFeatureRampEvent = (featureRampName: string): void => {
    const featureRampConfig: FeatureRampConfig = serverVars.get(FEATURE_RAMP_CONFIG) || {};
    const featureRamp = featureRampConfig[featureRampName];

    /**
     * Feature ramp won't have a confing:
     * - if there is no server side query param
     * - if the feature ramp is disabeled by a feature flag
     */
    if (!featureRamp) {
        return;
    }

    trackEvent(
        {
            category: 'feature ramping',
            action: 'page_view',
            label: featureRamp.status.toLowerCase(),
            additional: {
                cdnTestConfigType: 'standard',
                cdnFeatureRamp1: `[${featureRampName}] - ${featureRamp.status}`,
            },
        },
        null
    );
};
